import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider, MenuItem, Grid, InputLabel, TextField } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import MaterialTable from "material-table";
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import tokenService from '../../../utils/tokenDecoder';
import xlsx from 'json-as-xlsx';
import { Face } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorRecord: {
        backgroundColor: "green",
    },
}));

const screenCode = 'SKUMASTER';

export default function SKUMasterListing() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [skuTypes, setSkuTypes] = useState();
    const [skuCategory, setSkuCategory] = useState();
    const [skuViewData, setSkuViewData] = useState([]);
    const [initialState, setIsInitialState] = useState(false);
    const [IDDataForCall, setIDDataForCall] = useState(null);
    const [page, setPage] = useState(0);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [skuDetails, setSkuDetails] = useState({
        groupID: 0,
        factoryID: 0,
        sKUTypeID: 0,
        skUCategoryID: 0,
        sKUMasterCode: '',
        sKUMasterName: '',
        reOrderLevel: '',
        maxLevel: '',
        minLevel: '',
        isActive: 2,
        skuMasterID: 0,
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: "0",
        factoryName: "0",
        sKUTypeName: '',
        skUCategoryName: '',
    })

    let encrypted = "";

    const handleClick = () => {
        encrypted = btoa('0');
        let modelID = {
            groupID: parseInt(skuDetails.groupID),
            factoryID: parseInt(skuDetails.factoryID),
            skuMasterID: parseInt(skuDetails.skuMasterID),
            sKUTypeID: parseInt(skuDetails.sKUTypeID),
            skUCategoryID: parseInt(skuDetails.skUCategoryID),
            sKUMasterCode: skuDetails.sKUMasterCode,
            sKUMasterName: skuDetails.sKUMasterName,
            isActive: skuDetails.isActive,
        };

        sessionStorage.setItem('sku-list-page-search-parameters-id', JSON.stringify(modelID));
        sessionStorage.setItem('sku-table-page', JSON.stringify(page));
        navigate('/app/skuMaster/addEdit/' + encrypted);
    }

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
    });

    useEffect(() => {
        getPermissions(null, 0);
        getGroupsForDropdown();
    }, []);

    useEffect(() => {
        trackPromise(getSKUTypesForDropdown());
    }, []);

    useEffect(() => {
        if (skuDetails.groupID != 0 && skuDetails.factoryID != 0) {
            trackPromise(
                getSKUTCategoriesForDropdown(skuDetails.groupID, skuDetails.factoryID ,skuDetails.sKUTypeID)
            );
        } else {
            setSkuDetails(prev => ({
                ...prev,
                skUCategoryID: 0
            }));
            setSkuCategory([]);
        }
    }, [skuDetails.groupID, skuDetails.factoryID , skuDetails.sKUTypeID])

    useEffect(() => {
        if (skuDetails.groupID != 0) {
            trackPromise(
                getFactoriesForDropdown(skuDetails.groupID)
            );
        }
    }, [skuDetails.groupID])

    useEffect(() => {
        if (skuDetails.sKUTypeID == 0) {
            setSkuDetails((prev) => ({
                ...prev,
                skUCategoryID: 0
            }))
            setSkuCategory()
        }
    }, [skuDetails.sKUTypeID])

    async function getPermissions(IDdata, page) {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSKUMASTER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        const initialValues = IDdata === null || undefined
        if (initialValues) {
            setSkuDetails({
                ...skuDetails,
                groupID: parseInt(tokenService.getGroupIDFromToken()),
                factoryID: parseInt(tokenService.getFactoryIDFromToken()),
            })
        }
        else {
            setSkuDetails({
                ...skuDetails,
                groupID: parseInt(IDdata.groupID),
                factoryID: parseInt(IDdata.factoryID),
                skuMasterID: parseInt(IDdata.skuMasterID),
                sKUTypeID: parseInt(IDdata.sKUTypeID),
                skUCategoryID: parseInt(IDdata.skUCategoryID),
                sKUMasterCode: IDdata.sKUMasterCode,
                sKUMasterName: IDdata.sKUMasterName,
                isActive: IDdata.isActive,
            })
            setIDDataForCall(IDdata);
            setPage(page);
        }
        setIsInitialState(true);
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropdown(groupID) {
        const factories = await services.getAllFactoriesByGroupID(groupID);
        setFactories(factories);
    }

    async function getSKUTypesForDropdown() {
        const skuTypes = await services.GetSKUTypes();
        setSkuTypes(skuTypes);
    }

    async function getSKUTCategoriesForDropdown(groupID, factoryID ,sKUTypeID) {
        const SKUCategoryNames = await services.GetSKUCategoryNamesByID(groupID, factoryID , sKUTypeID);
        setSkuCategory(SKUCategoryNames);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setSkuDetails({
            ...skuDetails,
            [e.target.name]: value
        });
        setSkuViewData([]);
    }

    async function getData() {
        let model = {
            groupID: parseInt(skuDetails.groupID),
            factoryID: parseInt(skuDetails.factoryID),
            budgetCodeID: parseInt(skuDetails.sKUTypeID),
            skUCategoryID: parseInt(skuDetails.skUCategoryID),
        }

        if (skuDetails.isActive == 1 || skuDetails.isActive == 0) {
            model.isActive = skuDetails.isActive == 1 ? true : false;
        }

        let response = await services.GetSKUDetails(model);
        if (response.statusCode === "Success") {
            setSkuViewData(response.data);
        } else {
            alert.error(response.message || "No Records to Display.");
        }
        getSelectedDropdownValuesForReport(skuDetails.groupID, skuDetails.factoryID, skuDetails.sKUTypeID, skuDetails.skUCategoryID)
    }

    const handleClickEdit = (skuMasterID) => {
        encrypted = btoa(skuMasterID);
        let modelID = {
            groupID: parseInt(skuDetails.groupID),
            factoryID: parseInt(skuDetails.factoryID),
            skuMasterID: parseInt(skuDetails.skuMasterID),
            sKUTypeID: parseInt(skuDetails.sKUTypeID),
            skUCategoryID: parseInt(skuDetails.skUCategoryID),
            sKUMasterCode: skuDetails.sKUMasterCode,
            sKUMasterName: skuDetails.sKUMasterName,
            isActive: skuDetails.isActive,
        };

        sessionStorage.setItem('sku-list-page-search-parameters-id', JSON.stringify(modelID));
        sessionStorage.setItem('sku-table-page', JSON.stringify(page));
        navigate('/app/skuMaster/edit/' + encrypted);
    }

    useEffect(() => {
        const savedFilters = JSON.parse(
            sessionStorage.getItem('sku-list-page-search-parameters-id')
        );
        const savedPage = JSON.parse(
            sessionStorage.getItem('sku-table-page')
        );

        if (savedFilters) {
            setSkuViewData(savedFilters);
        }
        if (savedPage) {
            setPage(savedPage);
        }

        getPermissions(savedFilters, savedPage);
    }, []);

    useEffect(() => {
        if (initialState) {
            setSkuDetails((prevState) => ({
                ...prevState,
                groupID: 0,
                factoryID: 0,
                skuMasterID: 0,
                sKUTypeID: 0,
                skUCategoryID: 0,
                sKUMasterCode: '',
                sKUMasterName: '',
            }));
        }
    }, [initialState]);

    useEffect(() => {
        if (skuDetails.groupID !== 0) {
            setSkuDetails(prev => ({
                ...prev,
                skUCategoryID: 0
            }));
            setSkuCategory();
        }
    }, [skuDetails.groupID])

    useEffect(() => {
        sessionStorage.removeItem(
            'sku-list-page-search-parameters-id'
        );
        sessionStorage.removeItem(
            'sku-table-page'
        );
    }, []);

    function getSelectedDropdownValuesForReport(groupID, factoryID, sKUTypeID, skUCategoryID) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups[groupID],
            factoryName: factories[factoryID],
            sKUTypeName: skuTypes[sKUTypeID],
            skUCategoryName: skuCategory[skUCategoryID],
        })
    }

    async function createDataForExcel(array) {

        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'SKU Code': x.skuMasterCode,
                    'SKU Name': x.skuMasterName,
                    'Measuring Unit': x.measuringUnitName,
                    'Description': x.skuMasterDescription == undefined ? '-' : x.skuMasterDescription,
                    'Max Level': x.maxLevel != null ? x.maxLevel.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
                    'Min Level': x.minLevel != null ? x.minLevel.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
                    'Re-Order Level': x.reOrderLevel != null ? x.reOrderLevel.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
                    'Status': x.isActive ? 'Active' : 'InActive',
                };
                res.push(vr);
            });
            res.push([])
            res.push([])
            var vr = { 'SKU Code': 'Group : ' + selectedSearchValues.groupName };
            res.push(vr);
            var vr = { 'SKU Code': 'Factory : ' + selectedSearchValues.factoryName };
            res.push(vr);
            var vr = { 'SKU Code': 'Account Code Name : ' + selectedSearchValues.sKUTypeName };
            res.push(vr);
            var vr = { 'SKU Code': 'SKU Category : ' + selectedSearchValues.skUCategoryName };
            res.push(vr);
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(skuViewData);

        var fileName = 'SKU Master Details - ' + selectedSearchValues.groupName + ' ' + 'Account Code Name - ' + selectedSearchValues.sKUTypeName + ' SKU Category - ' + selectedSearchValues.skUCategoryName;
        var settings = {
            sheetName: 'SKU Master Details',
            fileName: fileName,
            writeOptions: {}
        }

        let keys = Object.keys(file[0]);
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem });
        });

        let dataA = [
            {
                sheet: 'SKU Master Details',
                columns: csvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                        isEdit={true}
                        toolTiptitle={"Add SKU Details"}
                    />
                </Grid>
            </Grid>
        )
    }

    function clearData() {
        setSkuDetails({
            ...skuDetails,
            sKUTypeID: 0,
            skUCategoryID: 0,
            sKUMasterCode: '',
            sKUMasterName: '',
            isActive: 2,
        });
        setSkuViewData([]);
        setSkuCategory([]);
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title="SKU Master"
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: skuDetails.groupID,
                            factoryID: skuDetails.factoryID,
                            sKUTypeID: skuDetails.sKUTypeID,
                            skUCategoryID: skuDetails.skUCategoryID,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                sKUTypeID: Yup.number().required('Account Code Name is required').min("1", 'Account Code Name is required'),
                            })
                        }
                        onSubmit={() => trackPromise(getData())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            props
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle("SKU Master")}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            fullWidth
                                                            name="factoryID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.factoryID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="sKUTypeID">
                                                            Account Code Name *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.sKUTypeID && errors.sKUTypeID)}
                                                            helperText={touched.sKUTypeID && errors.sKUTypeID}
                                                            fullWidth
                                                            name="sKUTypeID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.sKUTypeID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                        >
                                                            <MenuItem value={0}>--Select Account Code Name--</MenuItem>
                                                            {generateDropDownMenu(skuTypes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="skUCategoryID">
                                                            SKU Category
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.skUCategoryID && errors.skUCategoryID)}
                                                            fullWidth
                                                            helperText={touched.skUCategoryID && errors.skUCategoryID}
                                                            name="skUCategoryID"
                                                            placeholder='--Select SKU Category--'
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={skuDetails.skUCategoryID}
                                                            variant="outlined"
                                                            id="skUCategoryID"
                                                        >
                                                            <MenuItem value={0}>--Select SKU Category--</MenuItem>
                                                            {generateDropDownMenu(skuCategory)}
                                                        </TextField>
                                                    </Grid>
                                                    {/* <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="sKUMasterCode">
                                                            SKU Code
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.sKUMasterCode && errors.sKUMasterCode)}
                                                            helperText={touched.sKUMasterCode && errors.sKUMasterCode}
                                                            fullWidth
                                                            size='small'
                                                            name="sKUMasterCode"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.sKUMasterCode}
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="sKUMasterName">
                                                            SKU Name
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.sKUMasterName && errors.sKUMasterName)}
                                                            helperText={touched.sKUMasterName && errors.sKUMasterName}
                                                            fullWidth
                                                            size='small'
                                                            name="sKUMasterName"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.sKUMasterName}
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="isActive">
                                                            Active
                                                        </InputLabel>
                                                        <TextField select
                                                            fullWidth
                                                            name="isActive"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                setSkuDetails({ ...skuDetails, isActive: e.target.value }); // Ensure state is updated
                                                            }}
                                                            value={skuDetails.isActive}
                                                            variant="outlined"
                                                            id="isActive"
                                                            size='small'
                                                        >
                                                            <MenuItem value="2">--Select All Status--</MenuItem>
                                                            <MenuItem value="1">Active</MenuItem>
                                                            <MenuItem value="0">Inactive</MenuItem>
                                                        </TextField>
                                                    </Grid> */}

                                                </Grid>
                                                <Grid container justify="flex-end" spacing={3}>
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            variant="outlined"
                                                            type="reset"
                                                            onClick={clearData}
                                                        >
                                                            Clear
                                                        </Button>
                                                    </Box>
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            type="submit"
                                                            variant="contained"
                                                        >
                                                            Search
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </CardContent>
                                            <Box minWidth={1050}>
                                                {skuViewData.length > 0 ? (
                                                    <MaterialTable
                                                        title="Multiple Actions Preview"
                                                        columns={[
                                                            { title: 'SKU Code', field: 'skuMasterCode' },
                                                            { title: 'SKU Name', field: 'skuMasterName' },
                                                            { title: 'Measuring Unit', field: 'measuringUnitName' },
                                                            {
                                                                title: 'Description',
                                                                field: 'skuMasterDescription',
                                                                render: rowData => rowData.skuMasterDescription == null ? '-' : rowData.skuMasterDescription
                                                            },
                                                            {
                                                                title: 'Max Level',
                                                                field: 'maxLevel',
                                                                render: rowData => rowData.maxLevel != null
                                                                    ? rowData.maxLevel.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                    : '-',
                                                                cellStyle: {
                                                                    textAlign: 'center',
                                                                    paddingRight: '80px',
                                                                },
                                                            },
                                                            {
                                                                title: 'Min Level',
                                                                field: 'minLevel',
                                                                render: rowData => rowData.minLevel != null
                                                                    ? rowData.minLevel.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                    : '-',
                                                                cellStyle: {
                                                                    textAlign: 'center',
                                                                    paddingRight: '80px',
                                                                },
                                                            },
                                                            {
                                                                title: 'Re-Order Level',
                                                                field: 'reOrderLevel',
                                                                render: rowData => rowData.reOrderLevel != null
                                                                    ? rowData.reOrderLevel.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                    : '-',
                                                                cellStyle: {
                                                                    textAlign: 'center',
                                                                    paddingRight: '80px',

                                                                },
                                                            },
                                                            { title: 'Status', field: 'isActive', render: rowData => rowData.isActive ? "Active" : "Inactive" },
                                                        ]}
                                                        data={skuViewData}
                                                        options={{
                                                            exportButton: false,
                                                            showTitle: false,
                                                            headerStyle: { textAlign: "left", height: '1%' },
                                                            cellStyle: { textAlign: "left" },
                                                            columnResizable: false,
                                                            actionsColumnIndex: -1,
                                                            pageSize: 10
                                                        }}
                                                        actions={[
                                                            {
                                                                icon: 'edit',
                                                                tooltip: 'Edit',
                                                                onClick: (event, rowData) => handleClickEdit(rowData.skuMasterID)
                                                            }
                                                        ]}
                                                    />
                                                ) : null}
                                                {skuViewData.length > 0 ?
                                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                                        <Button
                                                            color="primary"
                                                            id="btnRecord"
                                                            type="submit"
                                                            variant="contained"
                                                            style={{ marginRight: '1rem' }}
                                                            className={classes.colorRecord}
                                                            onClick={createFile}
                                                            size='small'
                                                        >
                                                            EXCEL
                                                        </Button>
                                                    </Box>
                                                    : null}
                                            </Box>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page >
        </Fragment>
    )
}
